import React, { useEffect, useState } from 'react';
import { EIconTypes } from 'constants/Icons';
import Button from 'components/atoms/Button';
import { EButtonSizesPX, EButtonVariants } from 'constants/Buttons';
import { useAuth } from 'models/authContext';
import {
  StyledLogoutButton,
  StyledMenuProfileItem,
  StyledProfileItem,
} from 'components/molecules/MenuProfileItem/styles';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { useTranslations } from 'hooks/useTranslations';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import LicenceStore from 'state/LicenceStore';

interface IMenuProfileItem {
  open: boolean;
  mobile: boolean;
  close: () => void;
}

const MenuProfileItem = ({ open, mobile, close }: IMenuProfileItem) => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { logOut, isLogOutLoading, user, getUser } = useAuth();
  const [userEmail, setUserEmail] = useState<string>('');
  const [userFullName, setUserFullName] = useState<string>('');
  const { isMobile, isTablet, isDesktop } = useThemeBreakpoint();

  useEffect(() => {
    if (user === null) {
      getUser();
    }
    if (user && user.email) {
      if (isDesktop && user.email.length > 23) {
        setUserEmail(`${user.email.slice(0, 23)}...`);
      } else if (isMobile && user.email.length > 44) {
        setUserEmail(`${user.email.slice(0, 44)}...`);
      } else {
        setUserEmail(user.email);
      }
    }
    if (user && user.firstName && user.lastName) {
      const fullName = `${user?.firstName} ${user?.lastName}`;
      if (isDesktop && fullName.length > 20) {
        setUserFullName(`${fullName.slice(0, 20)}...`);
      } else if (isMobile && fullName.length > 40) {
        setUserFullName(`${fullName.slice(0, 40)}...`);
      } else {
        setUserFullName(fullName);
      }
    }
  }, [user, isMobile, isTablet, isDesktop]);

  if (!user) {
    return null;
  }

  return (
    <div style={{ display: 'grid', gap: '4px', padding: '8px 10px' }}>
      <StyledMenuProfileItem open={open} mobile={mobile}>
        <StyledProfileItem open={open}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div id="name">
              <p>{userFullName}</p>
            </div>
            <div id="email">
              <p>{userEmail}</p>
            </div>
          </div>
          <div>
            <Button
              variant={EButtonVariants.contained}
              icon={EIconTypes.settings}
              sizePX={open ? EButtonSizesPX.px24 : EButtonSizesPX.px48}
              onClick={() => {
                LicenceStore.clearStore();
                if (!isDesktop) close();
                navigate(ERouteLinks.Account);
              }}
            />
          </div>
        </StyledProfileItem>
      </StyledMenuProfileItem>

      <StyledLogoutButton
        open={open}
        mobile={mobile}
        label={t('general.logout.button')}
        variant={EButtonVariants.contained}
        icon={EIconTypes.logout}
        onClick={() =>
          logOut(() => {
            LicenceStore.clearStore();
            navigate(ERouteLinks.Auth);
          })
        }
        isLoading={isLogOutLoading}
      />
    </div>
  );
};
export { MenuProfileItem };
